export default __webpack_public_path__ + "static/media/1632.fe16f41a.png";